// import { flu } from '@/js/global/fluorescent-vendor-deps.js'
import { t$2 } from '@/js/global/global'
import { shouldAnimate } from '@/js/global/helpers'
// import { backgroundVideoHandler } from '@/js/global/a11y-user'
import { register } from '@/js/global/shopify-theme-sections'
import { playButton } from '@/js/global/video-helpers'
// import { slideStop, slideDown, slideUp } from '@/js/vendor/slide-anim'
// import { ProductItem } from '@/js/modules/product-item'
import { animateImageWithText } from '@/js/global/animations'
// import { navigationDots } from '@/js/modules/carousel'


const selectors$9 = {
  playButtonVideo: "[data-play-button-block-video]",
  playButtonBlock: ".play-button-block"
};
register("image-with-text", {
  onLoad() {
    if (shouldAnimate(this.container)) {
      this.animateImageWithText = animateImageWithText(this.container);
    }
    const playButtonVideos = t$2(selectors$9.playButtonVideo, this.container);
    if (playButtonVideos.length) {
      this.playButtons = playButtonVideos.map(block => playButton(block.closest(selectors$9.playButtonBlock)));
    }
  },
  onUnload() {
    var _this$animateImageWit;
    (_this$animateImageWit = this.animateImageWithText) === null || _this$animateImageWit === void 0 ? void 0 : _this$animateImageWit.destroy();
    this.playButtons && this.playButtons.forEach(button => button.unload());
  }
});
